import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuBusinessPositionThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_BUSINESS_POSITION',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getBusinessPosition(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuBusinessPosition = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_BUSINESS_POSITION',
  async (data) => {
    const response = await FinancialAnalysisService.downloadBusinessPosition(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
